module.exports = __webpack_public_path__ + "img/thumb_down.98ed7f3d.svg";